<template>
  <v-dialog v-model="dialog" max-width="900" persistent @after-leave="onAfterLeave">
    <v-card class="pa-4">
      <v-card-title class="d-flex align-center justify-space-between">
        <span class="text-h6">{{ modalTitle }}</span>

        <v-btn icon variant="text" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="cool-card">
        <v-form ref="form" v-model="isValid">
          <!-- DATOS GENERALES -->
          <h3 class="text-h6 mb-4">Datos del Proyecto</h3>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Nombre del Proyecto"
                v-model="formData.nombreProyecto"
                :rules="[rules.required]"
                required
                prepend-inner-icon="mdi-folder"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
              label="Clave del Proyecto"
              v-model="claveProyectoUpper"
              :rules="[rules.required, rules.projectKey]"
              prepend-inner-icon="mdi-key"
              placeholder="Ej. PROJ-001"
              required
              :disabled="mode === 'edit'"
            />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="6">
             <v-select
                label="Unidad de Negocio"
                v-model="formData.unidadNegocio"
                :items="unitOptions"
                :loading="loadingUnits"
                :disabled="loadingUnits"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-domain"
                item-title="title"
                item-value="value"
                required
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-select
                label="Tipo de Proyecto"
                v-model="formData.tipoProyecto"
                :items="['QA', 'Manual']"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-tag"
                required
              />
            </v-col>
          </v-row>

          <v-divider class="my-6" />

          <!-- CONFIGURACIÓN -->
          <h3 class="text-h6 mb-4">Configuración</h3>

          <v-row>
            <v-col cols="12" md="4">
              <v-select
                label="Estado"
                v-model="formData.estado"
                :items="['Nuevo', 'En curso', 'Mantenimiento']"
                required
                :disabled="mode === 'create'"
              >
                <template #prepend-inner>
                  <v-icon color="blue">mdi-check-circle</v-icon>
                </template>
              </v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                label="Responsable"
                v-model="formData.responsable"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-account"
                required
              />
            </v-col>

            <v-col cols="12" md="4">
              <v-select
                label="Ambiente"
                v-model="formData.ambiente"
                :items="['DEV', 'QA', 'UAT', 'PROD']"
                :rules="[rules.required]"
                prepend-inner-icon="mdi-server"
                required
              />
            </v-col>
            <v-col>
              <v-textarea
                label="Descripción del Proyecto"
                v-model="formData.descripcion"
                prepend-inner-icon="mdi-text-box"
                auto-grow
                rows="3"
                counter="400"
                :rules="[rules.required,rules.min100]"
                required
              />
            </v-col>
          </v-row>
          
          <v-divider class="my-6" />

          <!-- INTEGRACIONES -->
          <div class="d-flex align-center justify-space-between mb-2">
            <h3 class="text-h6">Integraciones</h3>

            <v-switch
              v-model="jiraEnabled"
              label="Jira"
              color="success"
              inset
              hide-details
            />
          </div>

          <p class="text-body-2 text-medium-emphasis mb-4">
            Activa Jira para capturar credenciales y sincronizar incidencias.
          </p>

          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Jira Email"
                v-model="formData.jiraEmail"
                prepend-inner-icon="mdi-email"
                autocomplete="off"
                :disabled="!jiraEnabled"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                label="Jira Token"
                v-model="formData.jiraToken"
                prepend-inner-icon="mdi-key-variant"
                type="password"
                autocomplete="new-password"
                :disabled="!jiraEnabled"
              />
            </v-col>
          </v-row>
           <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="Jira Dominio"
                v-model="formData.jiraDomain"
                prepend-inner-icon="mdi-domain"
                type="text"
                autocomplete="new-password"
                :disabled="!jiraEnabled"
              />
            </v-col>
            <v-col cols="12" md="6">
            <v-select
              label="Jira Proyecto"
              v-model="formData.jiraproyect"
              :items="projectsJira"
              item-text="test"
              item-value="test"
              :rules="[rules.required]"
              prepend-inner-icon="mdi-server"
              :disabled="!jiraEnabled"
            />
          </v-col>
          </v-row>
          <div class="d-flex align-center justify-space-between mb-2">
            <h3 class="text-h6">Integraciones</h3>
            <v-switch
              v-model="xrayEnabled"
              label="xray"
              color="success"
              inset
              hide-details
            />
          </div>

          <p class="text-body-2 text-medium-emphasis mb-4">
            Activa XRay para capturar credenciales y sincronizar incidencias.
          </p>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                label="JXRAY Client"
                v-model="formData.xrayclient"
                prepend-inner-icon="mdi-account"
                autocomplete="off"
                :disabled="!xrayEnabled"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                label="XRAY Secret"
                v-model="formData.xraysecret"
                prepend-inner-icon="mdi-key-variant"
                type="password"
                autocomplete="new-password"
                :disabled="!xrayEnabled"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider />

      <v-card-actions class="justify-end">
        <v-btn variant="tonal" color="secondary" size="large" rounded="x1" @click="close">Cancelar</v-btn>

        <v-btn  variant="elevated" color="primary" size="large" rounded="x1" :disabled="!isValid" @click="save">
          {{ saveBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import '@/css/Proyectos/StyleTableProyect.css'
import '@/css/Proyectos/StyleTableNewProyect.css'
import chatgptIcon from '@/assets/chatgpt.png'
import { swal } from '@/utils/swal';
import { useSettingsStore } from "@/stores/settings";

export default {
  name: 'NuevoProyectoGPT',
  props: {
    modelValue: { type: Boolean, default: false },
    mode: { type: String, default: 'create' },
    project: { type: Object, default: null }
  },
  emits: ['update:modelValue', 'save'],

  data() {
    return {
      archivo:'',
      loading: false,
      messages: [
      ],
      API_URL: "/login/chat/",
      chatgptIcon,
      isValid: false,
      jiraEnabled: false,
      xrayEnabled: false,
      unitOptions: [],
      loadingUnits: false,
      formData: this.getEmptyForm(),
      rules: {
        required: v => !!v || 'Este campo es obligatorio',
        min3: v => (v && v.length >= 3) || 'Mínimo 3 caracteres',
        min100: v => (v && v.length >= 50) || 'Mínimo 50 caracteres',
        email: v => /.+@.+\..+/.test(v) || 'Email inválido',
        projectKey: v =>
          /^[A-Z]{4}-\d{3}$/.test(v) ||
          'Debe tener formato: 4 letras  - 3 números (Ej: PROJ-001)'
      }
    }
  },

  computed: {
    isDark() {
      const settings = useSettingsStore();
      return settings.theme === "dark";
    },
      claveProyectoUpper:{
        get(){
          return this.formData.claveProyecto
        },
        set(val){
          this.formData.claveProyecto=val.toUpperCase()
        }
      },
    dialog: {
      get() {
        return this.modelValue
      },
      set(v) {
        this.$emit('update:modelValue', v)
      }
    },

    modalTitle() {
      return this.mode === 'edit' ? 'Editar Proyecto' : 'Nuevo Proyecto'
    },
    saveBtnText() {
      return this.mode === 'edit' ? 'Guardar Cambios' : 'Guardar Proyecto'
    }
  },

  watch: {
    modelValue(val) {
      if (val) {
        this.fetchUnits()
        this.loadProject()
        this.$nextTick(() => this.$refs.form?.resetValidation?.())
      } else {
        requestAnimationFrame(() => {
          if (this.mode === 'create') this.reset()
          else this.$refs.form?.resetValidation?.()
        })
      }
    },
    project: {
      handler() {
        if (this.modelValue) this.loadProject()
      },
      deep: true
    }
  },
  methods: {
    getEmptyForm() {
      return {
        originalKey: null, 
        nombreProyecto: '',
        claveProyecto: '',
        unidadNegocio: '',
        tipoProyecto: '',
        estado: 'Nuevo',
        responsable: '',
        ambiente: '',
        descripcion: '',
        chatgpt: true,
        jiraproyect: '',
        jiraEmail: '',
        jiraToken: '',
        xrayClient: '',
        xraySecret: '',
        xrayclient:'',
        xraysecret:''
      }
    },
    
    loadProject() {
      if (this.mode !== 'edit' || !this.project) return

      const p = this.project

      const idProyect   = p.idProyect ?? p.clave ?? null
      const nameProyect = p.nameProyect ?? p.nombre ?? ''
      const unit        = p.UnitBussines ?? p.unidadNegocio ?? ''
      const typeProject = p.typeProject ?? p.tipo ?? ''
      const status      = p.status ?? p.estado ?? 'Nuevo'
      const accountable = p.accountable ?? p.qaLead ?? ''
      const environ     = p.environ ?? p.ambiente ?? ''
      const description = p.description ?? p.descripcion ?? ''

      this.formData = {
        ...this.getEmptyForm(),
        originalKey: idProyect,          
        nombreProyecto: nameProyect,
        claveProyecto: idProyect ?? '',
        unidadNegocio: unit,
        tipoProyecto: typeProject,
        estado: status,
        responsable: accountable,
        ambiente: environ,
        descripcion: description,
        chatgpt: !!(p.chatgpt ?? true),
        jiraproyect: p.jiraproyect ?? '',
        jiraEmail: p.jira?.email ?? p.jiraemail ?? '',
        jiraToken: p.jira?.token ?? p.jiratoken ?? ''
      }

      this.jiraEnabled = !!(this.formData.jiraEmail || this.formData.jiraToken || this.formData.jiraproyect)
      this.$nextTick(() => this.$refs.form?.resetValidation?.())
    },

    reset() {
      this.formData = this.getEmptyForm()
      this.jiraEnabled = false
      this.xrayEnabled = false
      this.isValid = false
      this.$refs.form?.resetValidation?.()
    },
    onAfterLeave() {
      this.$refs.form?.resetValidation?.()
      this.isValid = false

      if (this.mode === 'create') {
        this.formData = this.getEmptyForm()
        this.jiraEnabled = false
        this.xrayEnabled = false
      }
    },
    close() {
      this.$emit('update:modelValue', false)
    },
    async fetchUnits() {
      this.loadingUnits = true
      try {
        
        const resp = await fetch('/login/unit-bussines/')

        if (!resp.ok) {
          console.error("No pude cargar unidades:", resp.status)
          this.unitOptions = []
          return
        }
        const data = await resp.json()

        this.unitOptions = (data || []).map(u => ({
          title: u.nameUnitBussines,
          value: u.id
        }))
      } catch (e) {
        console.error("Error cargando unidades:", e)
        this.unitOptions = []
      } finally {
        this.loadingUnits = false
      }
    },

    async save() {
      let valid = true
      if (this.$refs.form?.validate) {
        const res = await this.$refs.form.validate()
        valid = typeof res === "boolean" ? res : !!res?.valid
      }
      if (!valid) return
      
      

      const isEdit = this.mode === "edit"

      const keyToUse = isEdit
        ? (this.formData.originalKey || "").trim()
        : (this.formData.claveProyecto || "").trim()

      if (!keyToUse) {
        console.error("Falta claveProyecto (idProyect)")
        return
      }
      if (keyToUse.length > 8) {
        console.error("La clave debe ser máximo 8 caracteres")
        return
      }
    
      const payload = {
        idProyect: keyToUse, 
        nameProyect: (this.formData.nombreProyecto || "").trim(),
        typeProject: (this.formData.tipoProyecto || "").trim(),
        status: this.formData.estado || "Nuevo",
        accountable: (this.formData.responsable || "").trim(),
        environ: (this.formData.ambiente || "").trim(),
        description: (this.formData.descripcion || "").trim(),
        chatgpt: true,

        jiraproyect: this.jiraEnabled ? (this.formData.jiraproyect || "").trim() : null,
        jiraemail: this.jiraEnabled ? (this.formData.jiraEmail || "").trim() : null,
        jiratoken: this.jiraEnabled ? (this.formData.jiraToken || "").trim() : null,

        xrayClient: this.xrayEnabled ? (this.formData.xrayclient || "").trim() : null,
        xraySecret: this.xrayEnabled ? (this.formData.xraysecret || "").trim() : null,
      
        UnitBussines: this.formData.unidadNegocio
      }

      const url = isEdit
        ? `/login/proyectos/${encodeURIComponent(keyToUse)}/`
        : '/login/proyectos/'

      const method = isEdit ? "PATCH" : "POST"

      try {
        const resp = await fetch(url, {
          method,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        })

        if (!resp.ok) {
          const err = await resp.json().catch(() => ({}))
          //console.log("WWW",resp)
          console.error("Error guardando:", resp.status, err)
          await swal({
            icon: "error",
            title: "Error",
            text: "No se pudo guardar el proyecto",
            customClass: {
              popup: this.isDark ? "mi-popup" : "mi-popup-2",
              title: "mi-titulo",
            },
          })
          return
        }

        const saved = await resp.json()

        this.$emit("save", saved)
        this.close()
      const projectName =
          (saved?.nameProyect || this.formData.nombreProyecto || "").trim()

        const projectKey =
          (saved?.idProyect || keyToUse || "").trim()

        const title = isEdit
          ? "Proyecto Actualizado"
          : "Proyecto Creado"

        const text = projectKey
          ? `El proyecto ${projectName} (${projectKey}) se ${
              isEdit ? "actualizó" : "creó"
            } correctamente.`
          : `El proyecto ${projectName} se ${
              isEdit ? "actualizó" : "creó"
            } correctamente.`

        await swal({
          icon: "success",
          title,
          text,
          timer: 2500,
          showConfirmButton: false,
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        })
      } catch (e) {
        console.error("Error de red:", e)

        await swal({
          icon: "error",
          title: "Error de red",
          text: "No se pudo conectar con el servidor",
          customClass: {
            popup: this.isDark ? "mi-popup" : "mi-popup-2",
            title: "mi-titulo",
          },
        })
      }
    }
  }
}
</script>
